<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('pending_invoice_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onShow"><i class="fa fa-money"></i> {{$t('make_payment')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row-flex-x">
                        <div>
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('invoice') }}</label>
                                <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>
                        <div class="form-group">
                                <label class="label-control blue">{{$t('customer')}}</label>
                                <div>
                                    <CustomerDropdown @clear="customerClear" @select="customerSelected" :vShowVat="false" :include-add-new="false" :value="header.CustomerName" place="Choose a customer"></CustomerDropdown>
                                </div>
                        </div>
                        <div>     
                            <DatePicker v-model="query.FromDate" :label="$t('from_date')"/>
                        </div>
                        <div>
                            <DatePicker v-model="query.ToDate" :label="$t('to_date')"/>                            
                        </div>                        
                        <div>
                            <div class="form-group">
                                <label class="control-label blue">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm no-bor">
                        <thead class="table-primary">
                        <tr>
                            <!-- <th class="text-center" style="width: 40px;"><input type="checkbox" v-model="isCheckAll"/></th> -->
                            <th></th>
                                <th>កាលបរិច្ឆេទ</th>
                                <th>លេខវិក្កយបត្រ</th>
                                <th>{{$t('due_date')}}</th>
                                <th>{{$t('customer')}}</th>
                                <th class="text-right" style="width: 150px;">{{$t('original_amount')}}</th>
                                <th class="text-right" style="width: 150px;">{{$t('open_balance')}}</th>
                                <th class="text-right" style="width: 150px;">{{$t('payment')}}</th>
                                <th class="text-left" style="width: 150px;">{{$t('status')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center"><input type="checkbox" :disabled="!ret.IsPayCustomer" v-model="ret.Checked" @change="isCheck(ret)"/></td>
                                <td>{{$format(ret.InvoiceDate,'DD/MM/YYYY')}}</td>
                                <td>{{ret.TaxNum}}</td>
                                <td>{{$format(ret.InvoiceDueDate,'DD/MM/YYYY')}}</td>
                                <td class="text-left">{{ret.Customer}}</td>
                                <td class="text-right">{{$money(ret.OriginalAmount)}}</td>
                                <td class="text-right">{{$money(ret.Balance)}}</td>
                                <td class="cell-input">
                                    <input :disabled="!ret.IsPayCustomer" type="text" class="form-control form-control-sm text-right" v-model="ret.ReceiveAmount" @blur="calculate" style="font-size: 14px;">
                                </td>
                                <td class="cell-badge" v-html="invStatus(ret)"></td>
                            </tr>
                        </tbody>                        
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
        <b-modal no-close-on-backdrop centered size="xl"
            modal-class="x-modal"
            title="Payment"
            ref="innerform"
            footer-class="justify-content-between">
            <div class="vl-parent" ref="ldCond">
                    <div class="row">                        
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.header.Num.$error }">
                                <label class="label-control blue">{{$t('receipt_no')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="$v.header.Num.$model" readonly/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.date.$error }">
                                <DatePicker v-model="$v.date.$model" :label="$t('date')"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('payment_method')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.PaymentMethodId">
                                        <option value=""></option>
                                        <option v-for="(ret,index) in paymentMethods" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.header.AccountId.$error }">
                                <label class="label-control blue">{{$t('deposit_to_account')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="$v.header.AccountId.$model">
                                        <option value=""></option>
                                        <option v-for="(ret,index) in banks" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('text_amount')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" readonly v-model="header.TextAmount">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group class="label-control blue" :label="$t('description')">
                                <b-form-textarea v-model="header.Description"/>
                            </b-form-group>
                        </div>
                    </div>
                <div class="row">
                    <div class="col-sm-12">
                        <ul style="padding: 0; margin: 0; list-style-type: none;">
                            <!-- <li v-for="(ret,index) in errors" :key="index" style="color: red; padding: 5px;">{{ index + 1 }}. {{  ret }}</li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <template #modal-footer class="justify-end">
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$refs.innerform.hide();"><i class="fa fa-close"></i> {{ $t('cancel') }}</button>
                <b-btn align="right" variant="outline-primary no-bor" size="sm" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
            </template>
        </b-modal>
    </div>
</template>
<script>
    import { CustomerDropdown } from '../Customer';
    import { required } from 'vuelidate/lib/validators';
    import { Sale } from '../../shared/models/model';
    import DatePicker from '../Components/DatePicker.vue';
    import { ToWords } from 'to-words';
    export default {
        components: { CustomerDropdown, DatePicker },
        data: function(){
            return {
                query:{
                    Text: '',
                    FromDate: '',
                    ToDate: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    CompanyId: this.$store.state.company.Id
                },
                list: [],                
                errors: [],
                header: {
                    Num: '',
                    CustomerId: '',
                    CustomerName: '',
                    Date: this.$now().format('YYYY-MM-DD'),
                    AccountId: '',
                    Amount: 0
                },
                lines: [],
                banks: [],
                paymentMethods: [],
                isUpdate: false,
                isCheckAll: false
            }
        },
        validations:{
            header: {
                Num: { required },                
                AccountId: { required }
            },
            date: { required },
        },        
        created(){
          this.toList();
          this.init();
        },        
        methods: {
            async init(){
                let loading = this.$loading.show();
                let req = {
                    CompanyId: this.$store.state.company.Id,
                    Statuses: ['Bank','Other Current Asset']
                };
                await this.$api().post('receipt/init-form', req).then(res => {
                    if(this.$isValid(res)){
                        let json = res.data.Json;
                        this.banks = json.Accounts;
                        this.paymentMethods = json.Methods;
                        this.header.Num = json.Header.Num;                        
                    }
                }).finally(() => { loading.hide(); });
            },            
            toList(){
                var loading = this.$loading.show();
                this.$api().post('invoice/list-pending', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Json.Invoices;
                        this.query.Total = res.data.Json.Total;
                    }
                }).finally(() => { loading.hide(); });
            },                       
            paging(e){
                this.query.Page = e;
                this.toList();
            },                        
            onShow(){
                this.$refs.innerform.show();
            },            
            invStatus(line){
                let cls = 'badge-danger';
                if(line.PaidStatus == 'Paid') {
                    cls = 'badge-success';
                }
                else if(line.PaidStatus == 'Partially Paid') {
                    cls = 'badge-warning';
                }
                return '<span class="badge '+cls+'">' + line.PaidStatus + '</span>';
            },
            calculate(){
                let total = 0;
                let desc = [];
                this.list.forEach(el => {
                    if(el.ReceiveAmount > 0 && !el.Checked) el.Checked = true;
                    total += Number(el.ReceiveAmount);
                    if(el.Checked){
                        let msg = el.TaxNum;
                        if(el.Balance - el.ReceiveAmount == 0)
                            msg += '(Paid)';
                        else msg += '(Partially)';
                        desc.push(msg);
                    }
                });
                this.header.Amount = total;
                this.header.Description = 'Payment for invoice no: ' + desc.join(', ');
                this.toTextAmount();
            },
            isCheck(item){
                if(item.Checked) item.ReceiveAmount = item.Balance;                
                else item.ReceiveAmount = 0;
                this.calculate();                
                this.unCheckCus(item);
            },
            toTextAmount(){
                const toWords = new ToWords({localeCode: 'en-US'});
                this.header.TextAmount = toWords.convert(this.header.Amount, { currency: true });
            },
            onSave(){
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    let lines = this.list.filter(el => el.Checked == true);
                    if(lines.length == 0){
                        this.$swal.fire('សារបញ្ជាក់', 'សូមធ្វើការជ្រើសរើសវិក្កយបត្រលក់យ៉ាងតិច១។', 'warning');
                        return;
                    }
                    this.header.Date = this.date;
                    this.header.CompanyId = this.$store.state.company.Id;
                    this.header.ClientId = this.$store.state.company.ClientId;
                    var req = {
                        Header: this.header,
                        Lines: lines
                    };
                    var loading = this.$loading.show();
                    Sale.saveReceipt(req, this.isUpdate).then(() => {
                        this.$router.go(-1);
                    }).finally(() => { loading.hide(); });
                }
            },            
            customerSelected(e){
                this.query.CustomerId = e.data.Id
                this.toList();                
            },
            customerClear() {
                this.query.CustomerId = null;
                this.toList();                
            },
            unCheckCus(item) {                
                if(item.Checked == true) {
                    this.list.forEach(el => {
                        if(el.Customer != item.Customer) el.IsPayCustomer = false;
                    });
                    this.header.CustomerId = item.CustomerId;
                } else {
                    let resetCheck = true;
                    this.list.forEach(el => {
                        if(el.Checked == true) resetCheck = false;
                    });
                    if(resetCheck) {
                        this.list.forEach(el => {
                            el.Checked = false;                            
                            el.IsPayCustomer = true;                            
                        }); 
                        this.header.CustomerId = "";
                    }
                }
            }
        }
    }
</script>
